import { getToken, doFetch } from './utils/Fetching.js';
import { toast_message } from './utils/toast_message.js';
import { api_host, all_jobs_store, user_info_store, company_details_store, business_hours_store } from './stores.js';


export const init_data = async (init_type) => {
	const { auth_type, auth_token, domain_code } = getToken();

	let prev_error_msg = '';

	if (init_type === 'all' || init_type === 'jobs') {
		const all_jobs_res = await doFetch(
			`${api_host}/api/job/get/all/1`,
			'GET',
			null,
			{ Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
		);

		if (all_jobs_res.status) {
			all_jobs_store.set(all_jobs_res.jobs);
			let profits = 0;
			for (let i = 0; i < all_jobs_res.jobs.length; i ++) {
				const job = all_jobs_res.jobs[i];
				profits += job.total_service_price;
			}
			// total_earned_store.set(profits);
            if (all_jobs_res.is_lazy_loaded) {
                new Promise(async (resolve, reject) => {
                    const rest_all_jobs_res = await doFetch(
                        `${api_host}/api/job/get/all/0`,
                        'GET',
                        null,
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    all_jobs_store.set([...all_jobs_res.jobs, ...rest_all_jobs_res.jobs]);
                    let rest_profits = 0;
                    for (let i = 0; i < rest_all_jobs_res.jobs.length; i ++) {
                        const job = rest_all_jobs_res.jobs[i];
                        rest_profits += job.total_service_price;
                    }
                    // total_earned_store.set(profits + rest_profits);
                });
            }
		} else {
			const error_msg = all_jobs_res.msg || 'Fetching jobs failed';
			if (prev_error_msg !== error_msg)
				toast_message(false, error_msg, 3000);
			prev_error_msg = error_msg;
		}
	}

    if (init_type === 'all' || init_type === 'company_details') {
        const company_details_res = await doFetch(
            `${api_host}/api/landscaper/get/company_detail`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (company_details_res.status) {
            company_details_store.set({...company_details_res.company_details, ...company_details_res.owner});
            business_hours_store.set(company_details_res.business_hours);
        } else {
            const error_msg = company_details_res.msg || 'Fetching company details failed';
            if (prev_error_msg !== error_msg)
                toast_message(false, error_msg, 3000);
            prev_error_msg = error_msg;
        }
    }
}

export const get_user_info = async (uid) => {
    const { auth_type, auth_token, domain_code } = getToken();

    const user_res = await doFetch(
        `${api_host}/api/get/user/${uid}/1`,
        'GET',
        null,
        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
    );
    if (user_res.status) {
        console.log(user_res);
        const { profile, services } = user_res;
        user_info_store.set({ profile, services });
        if (user_res.is_lazy_loaded) {
            new Promise(async (resolve, reject) => {
                const rest_user_res = await doFetch(
                    `${api_host}/api/get/user/${uid}/0`,
                    'GET',
                    null,
                    { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                );
                const { services: _services } = rest_user_res;
                user_info_store.set({
                    profile,
                    services: [...services, ..._services]
                });
            });
        }
    } else {
        toast_message(false, user_res.msg || 'Fetching user information failed', 3000);
    }
}